import DateRangePicker from "components/DateRangePicker";
import {
  IsoPeriod,
  PickerRange,
  toIsoPeriod,
  toPickerRange,
} from "@/utils/date-range";

import { AUDIT_LABELS } from "../messages";

interface AuditPeriodProps {
  start: string;
  end: string;
  onChange: (period: IsoPeriod) => void;
}

export function AuditPeriod({
  start,
  end,
  onChange,
}: AuditPeriodProps): JSX.Element {
  return (
    <DateRangePicker
      date={toPickerRange({ start, end })}
      onDateChange={(range?: PickerRange) => onChange(toIsoPeriod(range))}
      allowUnlimited
      placeholder={AUDIT_LABELS.FILTER_PERIOD_PLACEHOLDER}
    />
  );
}
